import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { taxRoutes } from './_tax';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(taxRoutes)
  ]
})
export class TaxModule { }
